import {profileModal} from '../redux/profileModal';


/** @type {ReduxRequestActions|ReactReduxModalActions} */
export const updateProfileActions = profileModal.actions;



// WEBPACK FOOTER //
// ./src/js/user-profile/actions/profile.js